module.exports = __webpack_public_path__ + "static/media/JosefinSans-Regular.70e2eb76.ttf";